export const VOICE_NOTE_MAX_DURATION_SEC = 10 * 60;

// Chrome/Firefox record webm, Safari records mp4. Order is preference.
const RECORDING_TYPES = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4'];

export const pickRecordingType = (
  isTypeSupported: (type: string) => boolean
): string | undefined => RECORDING_TYPES.find(isTypeSupported);

// The backend allowlist matches content types exactly, so codec suffixes
// such as ';codecs=opus' must be dropped before upload.
export const toBaseContentType = (mimeType: string): string =>
  mimeType.split(';')[0].trim();

// A user-given recording name becomes the file name, like mobile's
// "Recording name" field; otherwise fall back to mobile's default.
export const getVoiceNoteFileName = (
  contentType: string,
  name = '',
  timestamp = Date.now()
): string =>
  `${name.trim() || `voice_note_${timestamp}`}.${
    contentType === 'audio/mp4' ? 'm4a' : 'webm'
  }`;

const pad = (value: number) => String(value).padStart(2, '0');

export const formatDuration = (seconds: number): string => {
  if (!Number.isFinite(seconds) || seconds < 0) return '--:--';
  const total = Math.floor(seconds);
  return `${pad(Math.floor(total / 60))}:${pad(total % 60)}`;
};

// Default recording name, e.g. "Voice075859" for 07:58:59 (as in the design).
export const getDefaultVoiceNoteName = (date = new Date()): string =>
  `Voice${[date.getHours(), date.getMinutes(), date.getSeconds()]
    .map(pad)
    .join('')}`;

// Squeezes recorded levels (0–1, one per sample tick) into `count` bars,
// keeping each bucket's peak so short spikes stay visible.
export const downsampleLevels = (levels: number[], count: number): number[] => {
  if (levels.length <= count) return levels;
  const size = levels.length / count;
  return Array.from({ length: count }, (_, index) =>
    Math.max(
      ...levels.slice(Math.floor(index * size), Math.floor((index + 1) * size))
    )
  );
};
